export default "__VITE_ASSET__D45zh0pu__"